import React, { useId, useState } from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import {
  formatUsPhoneInput,
  getUsPhoneState,
  normalizeUsPhone,
} from '../../services/usPhoneNumber';

export default function PhoneNumberField({ value, onChange }) {
  const helpId = useId();
  const [touched, setTouched] = useState(false);
  const state = getUsPhoneState(value);
  const showError = state.status === 'invalid' || (touched && state.status === 'incomplete');
  const showValid = state.status === 'valid';

  let message = 'Enter a 10-digit US phone number.';
  if (state.status === 'incomplete' && !showError) {
    message = `${state.remaining} digit${state.remaining === 1 ? '' : 's'} remaining.`;
  } else if (showError) {
    message = state.status === 'incomplete'
      ? 'Enter all 10 digits of your US phone number.'
      : 'Enter a valid US phone number, including area code.';
  } else if (showValid) {
    message = 'Valid phone number.';
  }

  return (
    <div className="lcw-input-group">
      <label className="lcw-label" htmlFor={`${helpId}-input`}>Phone</label>
      <div className="lcw-phone-input-wrap">
        <input
          id={`${helpId}-input`}
          className="lcw-input lcw-phone-input"
          data-invalid={showError ? 'true' : undefined}
          data-valid={showValid ? 'true' : undefined}
          type="tel"
          inputMode="tel"
          value={formatUsPhoneInput(value)}
          onChange={event => onChange(normalizeUsPhone(event.target.value))}
          onBlur={() => setTouched(true)}
          onFocus={() => setTouched(false)}
          placeholder="(555) 012-3456"
          autoComplete="tel-national"
          aria-invalid={showError}
          aria-describedby={helpId}
        />
        {showValid && <FiCheckCircle className="lcw-phone-valid-icon" aria-hidden="true" />}
      </div>
      <span
        id={helpId}
        className={showError ? 'lcw-field-error' : showValid ? 'lcw-field-success' : 'lcw-field-note'}
        role={showError ? 'alert' : undefined}
      >
        {message}
      </span>
    </div>
  );
}
